module.exports = __webpack_public_path__ + "static/img/1-1.cc2c436.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/1-1.png
// module id = rBO8
// module chunks = 0